import React, { Component } from "react";
import PropTypes from "prop-types";

class SentSMS extends Component {
  static propTypes = {
    sms: PropTypes.object
  };

  render() {
    return (
      <div className="m-b-40">
        <div className="form-group">
          <label>To</label>
          <input
            type="text"
            className="form-control to_field"
            disabled="disabled"
            value={this.props.sms.phone}
          />
        </div>

        <div className="form-group">
          <label>First Name</label>
          <input
            type="text"
            className="form-control first_name_field"
            disabled="disabled"
            value={this.props.sms.first_name}
          />
        </div>

        <div className="form-group">
          <label>Last Name</label>
          <input
            type="text"
            className="form-control last_name_field"
            disabled="disabled"
            value={this.props.sms.last_name}
          />
        </div>

        <div className="form-group">
          <label>Template</label>
          <input
            type="text"
            className="form-control sms_template_name_field"
            disabled="disabled"
            value={this.props.sms.sms_template_name}
          />
        </div>

        <div className="form-group">
          <label>Body</label>
          <div className="form-control body_field" disabled="disabled">
            {this.props.sms.body_text}
          </div>
        </div>
      </div>
    );
  }
}

export default SentSMS;
